<app-loader *ngIf="loader"></app-loader>
<section class="visible" id="dashboard_left">
  <app-navbar></app-navbar>
  <div class="container-fluid" *ngIf="results.length != 0">
    <div class="row">
      <div class="col-8 mt-md-1">
        <h3 class="text_color">Device diagnosis & Maintenance</h3>
      </div>
      <div class="col-4 mt-5 pl-0">
        <div class="row d-flex justify-content-end">
          <span class="selected_meter font-weight-bold">
            Device : {{ selected_meter_id }}
          </span>
          <!-- <span class="font-weight-bold selected_meter">Device 01 </span> -->
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <button
          class="btn add_btn text-light w-50 d-block ml-auto mt-2"
          (click)="createAppliance()"
        >
          Add device<i class="fas fa-plus ml-2"></i>
        </button>
      </div>
    </div>
    <div class="row mt-3 mb-5">
      <div
        class="col-6 card_items"
        *ngFor="let items of results; let index = odd"
        [ngClass]="odd ? 'odd' : 'even'"
      >
        <div class="card device_card">
          <div class="card-body">
            <div class="top_details" (click)="view_details(items)">
              <!-- <img src="../../../assets/img/ac.svg" alt="ac" class="img-fluid device_img"> -->
              <div class="row">
                <div class="col-8">
                  <img
                    src="../../../assets/img/ac.svg"
                    alt="ac"
                    class="img-fluid device_img"
                    *ngIf="items.applianceName == 'AC'"
                  />
                  <img
                    src="../../../assets/img/geyser.svg"
                    alt="ac"
                    class="img-fluid device_img"
                    *ngIf="items.applianceName == 'GEYSER'"
                  />
                  <img
                    src="../../../assets/img/washing_machine.svg"
                    alt="ac"
                    class="img-fluid device_img"
                    *ngIf="items.applianceName == 'WM'"
                  />
                  <img
                    src="../../../assets/img/heatingDevice.svg"
                    alt="ac"
                    class="img-fluid device_img"
                    *ngIf="items.applianceName == 'HEATING_DEVICE'"
                  />
                  <img
                    src="../../../assets/img/Fridge.svg"
                    alt="ac"
                    class="img-fluid device_img"
                    *ngIf="items.applianceName == 'FRIDGE'"
                    style="height: 40px"
                  />
                </div>
                <div class="col-4">
                  <img
                    src="../../../assets/img/successsmile.svg"
                    alt="successsmile"
                    class="img-fluid smile_icon"
                    *ngIf="items.healthStatus == 'HEALTHY'"
                  />
                </div>
              </div>
              <h6 class="text-danger mt-2">{{ items.applianceNickname }}</h6>
              <p class="mt-2">{{ items.applianceModelNo }}</p>
            </div>

            <div class="row d-flex align-items-center">
              <div class="col-12">
                <!-- [disabled]="items.canDiagnose === false" -->
                <button
                  class="btn diagnose_btn w-100 mt-2"
                  (click)="diagnose(items._id)"
                  [ngStyle]="{
                    background:
                      items.canDiagnose === false ? '#DAD7D7' : '#ee2f53',
                    cursor:
                      items.canDiagnose === false ? 'not-allowed' : 'pointer'
                  }"
                >
                  <img
                    src="../../../assets/img/heartbeat.svg"
                    alt="heartbeat"
                  />Diagnose
                </button>
                <!-- <button class="btn diagnose_btn w-100 mt-2" (click)="game(items._id)">Game</button> -->
              </div>
              <!-- <div class="col-4">
                <button
                  class="btn delete_btn"
                  (click)="deleteAppliance(items._id)"
                  style="z-index: 999999;"
                >
                  <img
                    src="../../../assets/img/delete.svg"
                    alt="delete"
                    class="img_fluid delete_img"
                  />
                </button>
              </div> -->

              <!-- <div class="col-2 p-0" (click)=editAppliance(items) style="cursor: pointer;"><img src="../../../assets/img/edit.svg" alt="edit" class="img_fluid edit_img"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid no_res" *ngIf="results.length == 0">
    <div class="row">
      <div class="col-8 mt-md-1">
        <h3 class="text_color">Device diagnosis & Maintenance</h3>
      </div>
      <div class="col-4 mt-5 pl-0">
        <div class="row d-flex justify-content-end">
          <span class="selected_meter font-weight-bold">
            Device : {{ selected_meter_id }}
          </span>
          <!-- <span class="font-weight-bold selected_meter">Device 01 </span> -->
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <img
              src="../../../assets/img/noDevice.png"
              alt="noDevice"
              class="img-fluid top_img"
            />

            <div class="row">
              <div class="col-12">
                <img
                  src="../../../assets/img/allAdd.svg"
                  alt="allAdd"
                  class="img-fluid"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <button
                  class="btn add_btn text-light w-50 d-block ml-auto mr-auto mt-5"
                  routerLink="/vyas-onboarding"
                >
                  Add device<i class="fas fa-plus ml-2"></i>
                </button>
              </div>
            </div>

            <!-- <div class="row mt-2">
              <div class="col-8">
                <h6>Vyas can help you with the health of your devices.</h6>
              </div>
            </div>
            <div class="row">
                <div class="col-">

                </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<app-bottom-navbar></app-bottom-navbar>
